import { DateTime } from "luxon";
import { normalizeCmpTimeZone } from "../../../utils/cmpTimeZones";

// Reject impossible dates and DST gaps. For a repeated local time, choose the
// first occurrence. Existing saved instants are retained by the form mapper.
export const eventDateTimeToUtcMilli = (date: string, time: string, timeZone?: string | null): number => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(time)) return NaN;
  const zone = normalizeCmpTimeZone(timeZone).timeZone;
  const parsed = DateTime.fromFormat(`${date} ${time}`, "yyyy-MM-dd HH:mm", { zone });
  if (!parsed.isValid || parsed.toFormat("yyyy-MM-dd HH:mm") !== `${date} ${time}`) return NaN;
  return Math.min(...parsed.getPossibleOffsets().map(value => value.toMillis()));
};

/** Date and time parts for design messages, e.g. "Sep 29, 2026" and "10:00 AM". */
export const formatEventScheduleParts = (
  utcMilli: number,
  timeZone?: string | null
): { date: string; time: string } => {
  const zone = timeZone || undefined;
  const moment = new Date(utcMilli);
  return {
    date: new Intl.DateTimeFormat("en-US", { timeZone: zone, month: "short", day: "numeric", year: "numeric" }).format(moment),
    time: new Intl.DateTimeFormat("en-US", { timeZone: zone, hour: "numeric", minute: "2-digit", hour12: true }).format(moment),
  };
};
